<template>
  <div>
    <error-box v-if="error" @reload="load()" />

    <loader v-else-if="loading" />

    <template v-if="!error && !loading">
      <v-teleport to="header">
        <div class="flex mb-20">
          <el-button-group>
            <el-button
              :type="onlyArchived ? 'default' : 'primary'"
              size="medium"
              round
              @click="onlyArchived = false">
              {{ $tc('general.active') }}
            </el-button>
            <el-button
              :type="onlyArchived ? 'primary' : 'default'"
              icon="el-icon-takeaway-box"
              size="medium"
              round
              @click="onlyArchived = true">
              {{ $tc('general.archive') }}
            </el-button>
          </el-button-group>
        </div>
      </v-teleport>

      <panel :title="$tc('tournament.tournament', 2)">
        <template v-slot:actions>
          <RouterLink :to="{ name: 'CreateTournament' }">
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="medium"
              round>
              {{ $tc('tournament.create_tournament') }}
            </el-button>
          </RouterLink>
        </template>

        <tournaments-table :data="filteredTournaments" />
      </panel>
    </template>
  </div>
</template>

<script>
import TournamentsTable from '@/components/tournaments/TournamentsTable'

export default {
  components: {
    TournamentsTable
  },

  data () {
    return {
      onlyArchived: false,
      editTournament: null,

      error: false,
      loading: false
    }
  },

  computed: {
    tournaments () {
      return this.$store.state.tournaments.data
    },

    filteredTournaments () {
      return this.tournaments.filter(tournament => {
        return this.onlyArchived ? tournament.isArchived : !tournament.isArchived
      })
    }
  },

  created () {
    this.$store.commit('app/set', {
      title: this.$tc('tournament.tournament', 2),
      breadcrumbs: [
        {
          text: this.$tc('tournament.tournament', 2)
        }
      ]
    })

    if (!this.myOwnClub) {
      this.load()
    }
  },

  methods: {
    async load () {
      this.loading = true
      try {
        await this.$store.dispatch('tournaments/load', this.clubId)
        this.error = false
      } catch (e) {
        console.error(e)
        this.error = true
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
